module.exports = __webpack_public_path__ + "img/f_1.81522822.jpg";